import { Injectable, signal } from '@angular/core';
import { API_SERVICES_CONFIG, NonPaginatedResourceConfig, PortalHttpClient } from '@grid-ui/common';
import { Observable } from 'rxjs';
import { DataWizardUploadColumnMap, DataWizardUploadSitesColumnMapping, DataWizardUploadSitesColumnMappingResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class DataWizardUploadSitesColumnMappingService {
  private resourceConfig: NonPaginatedResourceConfig;
  public selectedAttributes = signal<Array<{ key: string; label: string }>>([]);

  constructor(private readonly http: PortalHttpClient) {
    this.resourceConfig = API_SERVICES_CONFIG.v3.locations.uploads.sessions.session._configuration;
  }

  public updateColumnMappings(
    columnMapping: DataWizardUploadSitesColumnMapping,
    id: number,
  ): Observable<DataWizardUploadSitesColumnMappingResponse> {
    this.setSelectedAttributes(columnMapping.column_map);
    return this.http.patch<DataWizardUploadSitesColumnMappingResponse>(this.resourceConfig, {
      body: columnMapping,
      pathParams: { id },
    });
  }

  private setSelectedAttributes(fields: Array<DataWizardUploadColumnMap>) {
    this.selectedAttributes.set(
      fields.map((item) => ({
        key: item.key,
        label: item.given,
      })),
    );
  }

  public clearSelectedAttributes() {
    this.selectedAttributes.set([]);
  }
}
